import { Link } from "../utils/link";

export interface FetchManufacturersResponse {
    current_page:   number;
    data:           ManufacturerDataResponse[];
    first_page_url: string;
    from:           number;
    last_page:      number;
    last_page_url:  string;
    links:          Link[];
    next_page_url:  string;
    path:           string;
    per_page:       number;
    prev_page_url:  string | null;
    to:             number;
    total:          number;
}

export interface ManufacturerDataResponse {
    id:                number;
    email:             string;
    email_verified_at: string | null;
    id_number:         string;
    phone_number:      string;
    profile:           string;
    role_id:           number;
    created_at:        string;
    updated_at:        string;
    deleted_at:        string | null;
    name:              string;
    business_name:     string;
    address:           string;
    product_id:        number;
    user_id:           number;
}

